// extracted by mini-css-extract-plugin
export default {"bg-right-slope":"tsg_bg-right-slope__TrzF4","bg-left-slope":"tsg_bg-left-slope__z5Wgb","bg-left-slope-high":"tsg_bg-left-slope-high__3XDsv"};